import { API_BASE_URL } from "../config";
import type { VersionInfo } from "../types";

export async function fetchVersionInfo(specifier: string, platform = "ue5", solution?: string): Promise<VersionInfo | null> {
  const params = new URLSearchParams({ specifier, platform, ...(solution ? { solution } : {}) });
  const response = await fetch(`${API_BASE_URL}/version?${params}`);
  if (!response.ok) {
    throw new Error(`Version lookup failed for '${specifier}': ${response.status}`);
  }
  return response.json();
}
